<template>
  <div class="home">

    <!-- banner-slider start -->
    <div class="banner-slider">
      <div class="container">
        <banner-slider
          :data="bannerCarousel.data"
          :items="bannerCarousel.items"
          :margin="bannerCarousel.margin"
          :loop="bannerCarousel.loop"
          :autoplay="bannerCarousel.autoplay"
          :dots="bannerCarousel.dots"
        />
      </div>
    </div>
    <!-- banner-slider start -->

    <!-- advertise start -->
    <div class="advertise">
      <div class="container">
        <div class="row">
          <div class="col-md-6" v-for="(item,i) in addvertiseInfo" :key="i">
            <router-link  to="">
              <div class="single-add-item">
                <img :src="item.img" alt="addvertise image">
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- advertise end -->

    <!-- new-products start -->
    <div class="new-products">
      <div class="container">
        <div class="section-title">
          <h2>{{newProductsCarousel.head}}</h2>
          <router-link :to="newProductsCarousel.link" class="section-shop-btn" >shop more <i class="fa fa-angle-right"></i></router-link>
        </div>
        <offer-owl-carousel
          :data="newProductsCarousel.data"
          :items="newProductsCarousel.items"
          :margin="newProductsCarousel.margin"
          :loop="newProductsCarousel.loop"
          :autoplay="newProductsCarousel.autoplay"
          :nav="newProductsCarousel.nav"
          :navText="newProductsCarousel.navText"
          :responsive="newProductsCarousel.responsive"
          :dots="newProductsCarousel.dots"
        />
      </div>
    </div>
    <!-- new-products end -->

    <!-- top-brands start -->
    <div class="top-brands">
      <div class="container">
        <div class="section-title">
          <h2>{{topBrandsCarousel.head}}</h2>
          <router-link :to="topBrandsCarousel.link" class="section-shop-btn" >shop more <i class="fa fa-angle-right"></i></router-link>
        </div>
        <offer-owl-carousel
          :data="topBrandsCarousel.data"
          :items="topBrandsCarousel.items"
          :margin="topBrandsCarousel.margin"
          :loop="topBrandsCarousel.loop"
          :autoplay="topBrandsCarousel.autoplay"
          :nav="topBrandsCarousel.nav"
          :navText="topBrandsCarousel.navText"
          :responsive="topBrandsCarousel.responsive"
          :dots="topBrandsCarousel.dots"
        />
      </div>
    </div>
    <!-- top-brands end -->

    <!-- category start -->
    <div class="category">
      <div class="container">
        <category-card />
      </div>
    </div>
    <!-- category end -->

  </div>
</template>

<script>
  export default {
    name: 'home',
    data () {
      return {
        addvertiseInfo:[
          { img: 'https://bit.ly/2tCkQLc' },
          { img: 'https://bit.ly/2H2EpUM' }
        ],
        newProductsCarousel: {
          head: 'new products',
          link: '/newproducts',
          data: [
            {
              img : "https://bit.ly/2Tp8nZB",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2VwFMz4",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            }

          ],
          items    : 4,
          margin   : 15,
          loop     : true,
          autoplay : true,
          nav      : true,
          dots     : false,
          navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
          responsive:{
            0:{
              items:1,
              nav:false
            },
            640:{
              items:2,
              nav:true
            },
            992:{
              items:3,
              nav:true,
            },
            1199:{
              items:4,
              nav:true
            }
          }
        },
        topBrandsCarousel: {
          head: 'top brands',
          link: '/topbrands',
          data: [
            {
              img : "https://bit.ly/2Tp8nZB",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2VwFMz4",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            },
            {
              img : "https://bit.ly/2Uh8XGe",
              content : {
                title      : "dummy title",
                details    : "/product/id",
                offerPrice : "$125.00",
                oldPrice   : "$250.00",
                btn        :  "add to cart",
                link       :  "/"
              }
            }
          ],
          items    : 4,
          margin   : 15,
          loop     : true,
          autoplay : false,
          nav      : true,
          dots     : false,
          navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
          responsive:{
            0:{
              items:1,
              nav:false
            },
            640:{
              items:2,
              nav:true
            },
            992:{
              items:3,
              nav:true,
            },
            1199:{
              items:4,
              nav:true
            }
          }
        },
        bannerCarousel: {
          data: [
            {
              img : "assets/images/banner/bg.jpg",
              content : {
                head      :  "we have awesome products to offer you",
                para      :  "This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet                    Aenean sollicitudin, lorem quis bibendum auctor.",
                btn       :  "read more",
                link      :  "/"
              }
            },
            {
              img : "assets/images/banner/bg1.jpg",
              content : {
                head      :  "we have awesome products to offer you",
                para      :  "This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet                    Aenean sollicitudin, lorem quis bibendum auctor.",
                btn       :  "read more",
                link      :  "/"
              }
            },
            {
              img : "assets/images/banner/bg2.jpg",
              content : {
                head      :  "we have awesome products to offer you",
                para      :  "This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet                    Aenean sollicitudin, lorem quis bibendum auctor.",
                btn       :  "read more",
                link      :  "/"
              }
            }

          ],
          items    : 1,
          margin   : 0,
          loop     : true,
          autoplay : false,
          dots     : true,
        }

      }
    }
  }
</script>
